import React from 'react';
import './Framework.css';

function Framework() {
  return (
    <div>
      <h2 className='h2'>Libraries & Framework</h2>
      <div className='skill'>
        <p className='numpy'>NumPy</p>
        <p className='pandas'>Pandas</p>
        <p className='Matplotlib'>Matplotlib</p>
        <p className='Scikit-learn'>Scikit-learn</p>
        <p className='TensorFlow'>TensorFlow</p>
        <p className='PyTorch'>PyTorch</p>
        <p className='OpenCV'>OpenCV</p>
        <p className='Seaborn'>Seaborn</p>
        <p className='HF'>Hugging Face</p>
      </div>
    </div>
  )
}

export default Framework